import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {IUserDetails} from "@irb/app.model";
import { AppService } from '@irb/app.service';
import {delay, map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ModelMarketCenterService {

    firmInfoData: any;
    private originalFirmInfoData: any;
    mmcServiceUrlPrefix = '/mmc';

    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type':  'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };
    constructor(public _http: HttpClient, private as: AppService) {
        const useModelMarketService = this.as.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_MMC_APIS || false;
        if (useModelMarketService)
            this.mmcServiceUrlPrefix = '/model-market-service';
    }


    saveFirmDetails(infoData: any): Observable<Object> {
        return this._http.post('/mmc/model-provider', infoData);
    }

    updateModelProviderInfo(infoData: any): Observable<Object> {
        let url = `/model-market-service/model-provider`;
        return this._http.put(url, infoData).pipe(map(res => this.defineResponse(res)));
    }

    getModelProviderInfo(firmID: any) {
        let url = `/model-market-service/get-model-provider-info/${firmID}`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    getModelProvider() {
        let url = `${this.mmcServiceUrlPrefix}/get-model-provider`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    getFundFamilies() {
        let url = `/model-market-service/get-fund-families`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getModelMarketNotifications() {
        let url = `/model-market-service/get-model-market-notifications`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getMMCAgreement() {
        const rnd = (Math.random() * 10000000000).toFixed(0);
        let url = `${this.mmcServiceUrlPrefix}/get-model-shop-ua?angular.preventCache=${rnd}`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    acceptMMCUserAgreement() {
        let url = `/model-market-service/accept-model-shop-ua`;
        return this._http.get(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }
    getRoles() {
        const userDetails = this.as.getItem('IRB_APP_CONFIG') as IUserDetails;

        if (userDetails) {
            return {
                MMC_ADMIN: userDetails.isMMCAdmin,
                MMC_PROVIDER: userDetails.isModelProvider,
                MMC_PROVIDER_FIRST_TIME: userDetails.isModelProviderFirstLogin,
                MMC_ADVISOR: !userDetails.isMMCAdmin && !userDetails.isModelProvider,
                isCustomModelEnabled: userDetails.isCustomModelEnabled,
                isNewProviderUserForExistingFirm: userDetails.isNewProviderUserForExistingFirm,
                isMMCLimitedCustomModels: userDetails.isMMCLimitedCustomModels
            };
        }
        return {
            MMC_ADMIN: false,
            MMC_PROVIDER: false,
            MMC_PROVIDER_FIRST_TIME: true,
            MMC_ADVISOR: true,
            isCustomModelEnabled: false,
            isNewProviderUserForExistingFirm: false
        };
    }

    getFirmInfoData() {
        return this.firmInfoData;
    }

    clearFirmInfoData() {
        this.firmInfoData = null;
        this.originalFirmInfoData = null;
    }

    setFirmInfoData(newData: any) {
        this.firmInfoData = newData;
    }

    getOriginalFirmInfoData() {
        return this.originalFirmInfoData;
    }

    setOriginalFirmInfoData(newData: any) {
        this.originalFirmInfoData = JSON.parse(JSON.stringify(newData));
    }

    getMMCCustomPublishedForProvider(providerId: string) {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
            'X-HTTP-Method-Override':'GET',
            'Filter-Item':'items=0-49'
        });
        if (this.mmcServiceUrlPrefix === '/model-market-service') {
            headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT',
                'Filter-Item':'items=0-49'
            });
        }
        let filterKeys = '';
        filterKeys = filterKeys + 'modelProviderId=' + providerId;
        filterKeys = filterKeys + '&status=Published';
        filterKeys = filterKeys + '&usedFor=Custom'
        const payloadForCall: any = {
            filter: filterKeys,
            isExport: "false"
        };
        let url = `${this.mmcServiceUrlPrefix}/model-inventory`;
        return this._http.post(url, payloadForCall, {headers: headers}).pipe(map(res => this.defineResponse(res)));
    }

    checkProviderAssiciation(): Observable<Object> {
        let url = `/model-market-service/model-provider/user`;
        return this._http.post(url, null).pipe(map(res => this.defineResponse(res)));
    }


    validateImportMMCModelsAsync(_importData: any): Observable<Object> {
        let url = `${this.mmcServiceUrlPrefix}/async/validate-import-mmc-models`;
        return this._http.post(url, _importData, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    validateImportMMCModelsAsyncStatus(_statusId: string): Observable<Object> {
        let url = `${this.mmcServiceUrlPrefix}/async/async-response-map/${_statusId}`;
        return this._http.get<any>(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    importMMCModelsAsync(_importData: any): Observable<Object> {
        let url = `${this.mmcServiceUrlPrefix}/async/import-validated-mmc-models`;
        return this._http.post(url, _importData, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

    importMMCModelsAsyncStatus(_statusId: string): Observable<Object> {
        let url = `${this.mmcServiceUrlPrefix}/async/async-response-map/${_statusId}`;
      return this._http.get<any>(url, this.httpOptions).pipe(map(res => this.defineResponse(res)));
    }

  defineResponse(res: any) {
    return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
  }

}
